import React from 'react';

interface StepProps {
    recordId: string; // The record ID passed to the component
    handleClose: () => void; // Function to close the popup
    onUpdate: (updatedRecord: any) => void; // Function to refresh the data after update
    handleInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void; // Input change handler
    formData: {
        pinCode?: string;
        date?: string;
    }; // The form data
}

const PincodeDataPopup: React.FC<StepProps> = ({
    recordId,
    handleClose,
    onUpdate,
    handleInputChange,
    formData,
}) => {
    const handleSearch = () => {
        const updatedRecord = {
            recordId,
            ...formData,
        };
        onUpdate(updatedRecord);
    };

    return (
        <div className="popup-container" style={{ padding: '20px', fontFamily: 'Arial, sans-serif', fontSize: '14px' }}>
            <div className="popup-header" style={{ marginBottom: '20px' }}>
                <h4 style={{ fontSize: '16px', margin: '0 0 10px 0' }}>Campaign: Track Conversions</h4>
            </div>
            <div
                className="popup-content"
                style={{
                    height: '500px',
                    border: '1px solid #ddd',
                    padding: '20px',
                    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                }}
            >
                <h5 style={{ fontSize: '14px', margin: '0 0 10px 0' }}>Track conversions by pin code:</h5>

                <div style={{marginLeft:"30px"}}>
                <label htmlFor="pinCode" style={{ display: 'block', fontSize: '12px', marginBottom: '5px' }}>
                    5 Digits Pin Code:
                </label>
                <input
                    type="text"
                    id="pinCode"
                    name="pinCode"
                    value={formData.pinCode || ''}
                    onChange={handleInputChange}
                    style={{
                        width: '30%',
                        padding: '8px',
                        fontSize: '12px',
                        border: '1px solid #ddd',
                        borderRadius: '5px',
                        marginBottom: '15px',
                    }}
                />

                <label htmlFor="date" style={{ display: 'block', fontSize: '12px', marginBottom: '5px' }}>
                    Date:
                </label>
                <input
                    type="date"
                    id="date"
                    name="date"
                    value={formData.date || ''}
                    onChange={handleInputChange}
                    style={{
                        width: '30%',
                        padding: '8px',
                        fontSize: '12px',
                        border: '1px solid #ddd',
                        borderRadius: '5px',
                        marginBottom: '20px',
                    }}
                />
                <br></br>
                <button
                    onClick={handleSearch}
                    style={{
                        width: '30%',
                        padding: '10px',
                        backgroundColor: '#1173B7',
                        color: 'white',
                        fontSize: '14px',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer',
                    }}
                >
                    Search Data
                </button>
                </div>



            </div>
          
        </div>
    );
};

export default PincodeDataPopup;
